import React, { useEffect, useState } from 'react';
import Heading from '../../heading/heading';
import Footer from '../../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import './gallery.css';
import axios from '../../axios';



function Gallery() {
     const [AllData, setAllData] = useState([]);
     const [Loading, setLoading] = useState(false);


 const  fetchData = () => {
     setLoading(true);
    axios.get("/api/file")
    .then(data =>{
      setAllData(data.data)
      console.log(data.data)
      setLoading(false)
    })
    .catch(err => {console.log(err)
      setLoading(false);
    })
  
  }

   const submitHandler = (e) => {
     e.preventDefault();
   }
 
  useEffect(()=>{
     fetchData();
  },[])
  return (
    <div >
    <Heading />
    <div className='gallery_page'>
      <div style={{display:'flex', justifyContent:"flex-end",marginRight:'20px',marginTop:'20px'}}>
       <button className='btn btn-primary btn-sm mr-4' onClick={()=> window.open("/admin/auth","_self")}>Admin Panel</button>
    </div>
  <div>
        <div className='gallery_page_heading text-center'>Gallery</div>
          
          <div className='gallery_loading text-center' >{Loading ? "Loading Please wait.... ": ""}</div>
        <div className="gallery_row"> 
     {
       AllData.map((data) => (
         <div key={data._id} className="gallery_column">
           {data.FileType === "video/mp4" ? 
             <video src={data.FileUrl} className="gallery_video" controls></video>  :
              <img src={data.FileUrl} alt={data.Service} className="adminpanel_images"></img>}
              <div>
                <h6>{data.Location}</h6>
                <h6>{data.Service}</h6>
              </div>
         </div>
       ))
     }
      </div>

        </div>
        
    </div>
    
    <Footer />
      </div>
      
  )
}

export default Gallery